import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled from 'styled-components'

export const NavArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: ${COLORS.white};
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    background: ${COLORS.primaryLight};
  }

  svg {
    fill: ${COLORS.secondarySemiDark};
    width: 16px;
    height: 16px;
  }
`

export const PrevNavArrowButton = styled(NavArrowButton)`
  left: -88px;
`

export const NextNavArrowButton = styled(NavArrowButton)`
  right: -88px;

  svg {
    transform: rotate(180deg);
  }
`

export const SlideUpNavRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px 8px;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding: 4px 8px 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    z-index: 5;
    pointer-events: none;
  }
`

export const SlideUpNavArrowButton = styled.button`
  background: ${COLORS.white};
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    background: ${COLORS.primaryLight};
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  svg {
    fill: ${COLORS.secondarySemiDark};
    width: 14px;
    height: 14px;
  }

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    pointer-events: auto;

    svg {
      fill: ${COLORS.secondarySemiDark};
      width: 12px;
      height: 12px;
    }
  }
`
